// Référentiel des entités : code SYNC (Branch Flex), code cockpit (reporting CEX) et libellé.

export interface EntityDef {
  /** Code de l'établissement dans Flex (colonne Branch, sans espaces). */
  sync: string;
  /** Code utilisé par le reporting financier, null si l'entité n'est pas suivie dans le cockpit. */
  cockpit: string | null;
  label: string;
  inPlan: boolean;
  /** Libellé de l'établissement dans les factures clients (VIEW_AR_INVOICES_AND_MEMOS), source du CA du cockpit. */
  caEtab?: string;
}

export const ENTITIES: readonly EntityDef[] = [
  { sync: 'MARTINON', cockpit: 'MSE', label: 'Martinon', inPlan: true, caEtab: 'MARTINON' },
  { sync: 'PF', cockpit: 'PF', label: 'Provence Froid', inPlan: true, caEtab: 'PROVENCE FROID' },
  // Dimco : pas de caEtab tant que le périmètre (DIMCO seul ou avec DIMCO FRANCE) n'est pas arrêté ; le CA reste celui de la comptabilité.
  { sync: 'DIMCO', cockpit: 'DIMCO', label: 'Dimco', inPlan: true },
  { sync: 'DIMCO-FR', cockpit: null, label: 'Dimco FR', inPlan: true },
  { sync: 'FC33', cockpit: 'FC 33', label: 'Froid Cuisine 33', inPlan: true, caEtab: 'FROID CUISINE 33' },
  { sync: 'SAVEC', cockpit: 'SAVEC', label: 'Savec', inPlan: true, caEtab: 'SAVEC' },
  { sync: 'ALTECC', cockpit: 'ALTECC', label: 'Altecc', inPlan: true, caEtab: 'ALTECC' },
  { sync: 'SVREQUIPEM', cockpit: 'SVR', label: 'SVR Equipement', inPlan: true, caEtab: 'SVR EQUIPEMENT' },
  { sync: 'MIDITECH', cockpit: null, label: 'Miditech ITR', inPlan: true },
  { sync: 'ODICEENT', cockpit: null, label: 'Odice Entreprise', inPlan: false },
  { sync: 'ODICESERV', cockpit: null, label: 'Odice Services', inPlan: false },
  { sync: 'PF INDUSTR', cockpit: null, label: 'PF Industrie', inPlan: false },
];

/**
 * Entités SYNC visibles par un utilisateur, null = toutes.
 * Administrateur : toutes. Direction : toutes tant qu'aucune entité n'est précisée.
 * Directeur d'agence : uniquement celles qui lui sont attribuées, aucune par défaut.
 */
export function visibleSyncEntities(me: {
  role: 'admin' | 'direction' | 'da';
  entities: string[];
}): string[] | null {
  if (me.role === 'admin') return null;
  if (me.role === 'direction' && !me.entities.length) return null;
  return me.entities;
}

export const entityBySync = (code: string): EntityDef | undefined =>
  ENTITIES.find((e) => e.sync === code.trim());

export const entityByCockpit = (code: string): EntityDef | undefined =>
  ENTITIES.find((e) => e.cockpit === code);

/** Noms de clients qui désignent une société du groupe : une affaire à leur nom est intra-groupe. */
export const GROUP_CLIENT_NAMES = [
  'MARTINON',
  'SAVEC',
  'PROVENCE FROID',
  'FROID CUISINE 33',
  'ALTECC',
  'DIMCO',
  'SVR EQUIPEMENT',
  'MIDITECH',
  'ODICE',
  'PRODICE',
  'PF INDUSTRIE',
];
